/**
 * Created by LIDHCRT on 9/20/2018.
 */
module.exports = function(app) {
    app.directive('lifeEventValidation', [function() {
        return {

            restrict: 'A',
            require: 'ngModel',

            controller: ['$scope', '$element', function($scope, $element) {
                $scope.$watch('employee.data.globalCoverageEffectiveDate', function(n, o) {
                    if (n && n != o) {
                        if(window.location.href.indexOf('/find/review')!== -1) {
                            $scope.editCardSepForm.lifeEventDate.$validate();
                        } else{
                            $scope.subscriberForm.lifeEventDate.$validate();
                        }
                    }
                });
            }],

            link: function (scope, elem, attrs, ctrl) {
                ctrl.$validators.sepDateValidation = function (m, v) {
                    function truncateToDay(date) {
                        date.setHours(0);
                        date.setMinutes(0);
                        date.setSeconds(0);
                        date.setMilliseconds(0);
                        return date;
                    }
                    var valRet = false;
                    var valRet1 = true;
                    if(m instanceof Date) {
                        if(window.location.href.indexOf('/find/review')!== -1 && scope.lifeEventReason) {
                            scope.beforeDate = new Date(m.getFullYear(), m.getMonth(), m.getDate() - parseInt(scope.lifeEventReason.beforeDays));
                                scope.afterDate = new Date(m.getFullYear(), m.getMonth(), m.getDate() + parseInt(scope.lifeEventReason.afterDays));

                                var beforeDate = truncateToDay(new Date(scope.beforeDate));
                                var changeDate = truncateToDay(new Date(scope.employee.data.globalCoverageEffectiveDate));
                                var afterDate = truncateToDay(new Date(scope.afterDate));

                                valRet = (changeDate >= beforeDate && changeDate <= afterDate);
                                valRet1 = valRet? true:false;

                        } else if(window.location.href.indexOf('/add/subscriber')!== -1 && scope.employee.data.subscriber.eventCode && scope.employee.data.globalCoverageEffectiveDate){
                                    var newArray = [];
                                    newArray = scope.lifeEventValues.filter(function (el) {
                                        return el.lifeEventId === scope.employee.data.subscriber.eventCode;
                                    });
                                    scope.beforeDate = new Date(m.getFullYear(), m.getMonth(), m.getDate() - parseInt(newArray[0].beforeDays));
                                    scope.afterDate = new Date(m.getFullYear(), m.getMonth(), m.getDate() + parseInt(newArray[0].afterDays));

                                    var bforeDate = truncateToDay(new Date(scope.beforeDate));
                                    var cangeDate = truncateToDay(new Date(scope.employee.data.globalCoverageEffectiveDate));
                                    var aterDate = truncateToDay(new Date(scope.afterDate));

                                    valRet = (cangeDate >= bforeDate && cangeDate <= aterDate);
                                    valRet1 = valRet? true:false;

                        }


                    }
                    return valRet1;
                };
            }
        };
    }]);
};


